import React from "react";
import MenuBurger from "../../../helpers/MenuBurger";
import Drawer from "../../../helpers/Drawer";
import {NavigationVerticalMobile} from "../../../helpers/MerchantNavigation";

import {NAVIGATION_REFERRAL} from "../../constants";

import AccountDisplay from "../AccountDisplay";
import ReferralLogo from "../ReferralLogo";

export default () => {
  const [open, setOpenState] = React.useState();

  const toggleDrawer = () => setOpenState(!open);
  const closeDrawer = () => setOpenState(false);

  return (
    <>
      <div className="referral-layout__header mobile">
        <MenuBurger
          open={open}
          onClick={toggleDrawer}
        />
        <ReferralLogo />
        <AccountDisplay />
      </div>
      <Drawer
        open={open}
        closeDrawer={closeDrawer}
      >
        <NavigationVerticalMobile
          menu={NAVIGATION_REFERRAL}
          onClick={closeDrawer}
        />
      </Drawer>
    </>
  )
}
